import {
  Apartment, House, Villa, Cabin, Castle, Home, HolidayVillage,
  DirectionsBoat, BeachAccess, Cottage, HomeWork, Terrain, Yard,
  Park, Pets, MeetingRoom,
  AccessTime,
  AccountCircle,
  AcUnit,
  Assessment,
  Balcony,
  Bathtub,
  Block,
  BugReport,
  Build,
  BuildCircle,
  CameraAlt,
  Carpenter,
  Category,
  Celebration,
  Chair,
  ChildCare,
  CleaningServices,
  CropLandscape,
  Curtains,
  DesignServices,
  DirectionsBus,
  DirectionsCar,
  ElectricalServices,
  Elevator,
  EventAvailable,
  FormatPaint,
  GridOn,
  HouseSiding,
  HowToReg,
  Kitchen,
  Landscape,
  LocalLaundryService,
  LocalParking,
  MedicalServices,
  MusicNote,
  Notifications,
  Opacity,
  PersonOff,
  Plumbing,
  Pool,
  Print,
  RealEstateAgent,
  Security,
  SmokeFree,
  SmokingRooms,
  Videocam,
  VpnKey,
  WaterDrop,
  WbSunny,
  Weekend,
  WindPower,
} from '@mui/icons-material';

import {
  Clock, Snowflake, Plane, Zap, LandPlot, Flame, UtensilsCrossed,
  Sparkles, Trees, MoveVertical, BatteryCharging, Car, Lightbulb,
  Dumbbell, Thermometer, Bath, ChefHat, ParkingCircle, Waves,
  Accessibility, Wifi, Blocks, Gamepad2, Music, Music2, CircleDot,
  Tv, Baby, ShieldCheck, BookOpen, Sofa, Soup, Coffee, Utensils,
  GlassWater, Microwave, Refrigerator, Wind, Shirt, WashingMachine,
  Layers, Blinds, Archive, BedDouble, Bug, Footprints, SprayCan,
  Droplets, Droplet, ShowerHead, Hand, ScrollText, Briefcase, Lamp,
  Armchair, PlugZap, Printer, PenTool, Laptop, Camera, DoorOpen,
  Bell, FireExtinguisher, HeartPulse, Lock, Siren, IdCard,
  CalendarCheck, Volume2, Ban, VolumeX, PawPrint, CigaretteOff,
  UserX, PartyPopper, Moon, Cigarette,
  Delete,
  Factory,
  Fence,
  Hotel,
  School,
  VolumeOff,
  Warehouse,
} from 'lucide-react';



export interface CategoryItem {
  id: number;
  name: string;
  icon?: React.ReactNode; // for MUI icons
  image?: string;         // for custom images, e.g. "/icons/villa.png"
}

export const propertyCategories: CategoryItem[] = [
  { id: 1, name: "Luxury Home", icon: <Villa />, image: "/icons/property/luxury.png" },
  { id: 2, name: "Superhome", icon: <Home />, image: "/icons/property/superhome.png" },
  { id: 3, name: "Castle", icon: <Castle />, image: "/icons/property/castle.png" },
  { id: 4, name: "Villa", icon: <Villa />, image: "/icons/property/villa.png" },
  { id: 5, name: "Penthouse", icon: <Apartment />, image: "/icons/property/penthouse.png" },
  { id: 6, name: "Resort", icon: <HolidayVillage />, image: "/icons/property/resort.png" },
  { id: 7, name: "Yatchhouse", icon: <DirectionsBoat />, image: "/icons/property/yatchhouse.png" },
  { id: 8, name: "Beachfront", icon: <BeachAccess />, image: "/icons/property/beachfront.png" },
  { id: 9, name: "Romantic", icon: <Cottage />, image: "/icons/property/romantic.png" },
  { id: 10, name: "House", icon: <House />, image: "/icons/property/house.png" },
  { id: 11, name: "Cottage", icon: <Cottage />, image: "/icons/property/cottage.png" },
  { id: 12, name: "Bungalow", icon: <House />, image: "/icons/property/bungalow.png" },
  { id: 13, name: "Guesthouse", icon: <HomeWork />, image: "/icons/property/guesthouse.png" },
  { id: 14, name: "Cabin", icon: <Cabin />, image: "/icons/property/cabin.png" },
  { id: 15, name: "Countryside", icon: <Terrain />, image: "/icons/property/countryside.png" },
  { id: 16, name: "Farmstay", icon: <Yard />, image: "/icons/property/farmstay.png" },
  { id: 17, name: "Houseboat", icon: <DirectionsBoat />, image: "/icons/property/houseboat.png" },
  { id: 18, name: "Apartment", icon: <Apartment />, image: "/icons/property/apartment.png" },
  { id: 19, name: "Picnic", icon: <Park />, image: "/icons/property/picnic.png" },
  { id: 20, name: "Home", icon: <Home />, image: "/icons/property/home.png" },
  { id: 21, name: "Shared Home", icon: <Home />, image: "/icons/property/sharedhome.png" },
  { id: 22, name: "Shared Room", icon: <MeetingRoom />, image: "/icons/property/sharedroom.png" },
  { id: 23, name: "Pet Friendly", icon: <Pets />, image: "/icons/property/petfriendly.png" },
];



/* ──────────────────────────────────────────────
   🏠  GENERAL AMENITIES
────────────────────────────────────────────── */
export const amenitiesCategories: CategoryItem[] = [
  { id: 1, name: "24/7 Check-In", icon: <Clock /> },
  { id: 2, name: "Air Conditioning", icon: <Snowflake />, image: "/icons/amenities/airconditioner.png" },
  { id: 3, name: "Airport Transfer", icon: <Plane />, image: "/icons/amenities/airporttransfer.png" },
  { id: 4, name: "Backup Generator", icon: <Zap />, image: "/icons/amenities/generator.png" },
  { id: 5, name: "Balcony / Terrace", icon: <Home /> },
  { id: 6, name: "BBQ Grill", icon: <Flame />, image: "/icons/amenities/bbq.png" },
  { id: 7, name: "Breakfast Included", icon: <UtensilsCrossed />, image: "/icons/amenities/breakfast.png" },
  { id: 8, name: "Dry Sauna", icon: <Sparkles />, image: "/icons/amenities/drysauna.png" },
  { id: 9, name: "Eco-Friendly", icon: <Trees /> },
  { id: 10, name: "Elevator", icon: <MoveVertical />, image: "/icons/amenities/elevetor.png" },
  { id: 11, name: "EV Charging Station", icon: <BatteryCharging />, image: "/icons/amenities/evcharging.png" },
  { id: 12, name: "Fireplace", icon: <Flame />, image: "/icons/amenities/fireplace.png" },
  { id: 13, name: "Free Parking", icon: <Car />, image: "/icons/amenities/freeparking.png" },
  { id: 14, name: "Good Lighting", icon: <Lightbulb /> },
  { id: 15, name: "Gym / Fitness Center", icon: <Dumbbell />, image: "/icons/amenities/gym.png" },
  { id: 16, name: "Heating", icon: <Thermometer />, image: "/icons/amenities/heater.png" },
  { id: 17, name: "Jacuzzi / Hot Tub", icon: <Bath />, image: "/icons/amenities/jacuzzi.png" },
  { id: 18, name: "Kitchen", icon: <ChefHat />, image: "/icons/amenities/kitchen.png" },
  { id: 19, name: "Outdoor Grill", icon: <Flame /> },
  { id: 20, name: "Paid Parking", icon: <ParkingCircle />, image: "/icons/amenities/paidparking.png" },
  { id: 21, name: "Steam Sauna", icon: <Sparkles />, image: "/icons/amenities/steamsauna.png" },
  { id: 22, name: "Swimming Pool", icon: <Waves />, image: "/icons/amenities/swimpool.png" },
  { id: 23, name: "Wheelchair Accessible", icon: <Accessibility /> },
  { id: 24, name: "Wi-Fi", icon: <Wifi />, image: "/icons/amenities/wifi.png" },
];

/* ──────────────────────────────────────────────
   🎮  ENTERTAINMENT AMENITIES
────────────────────────────────────────────── */
export const EntertainmentAmenities: CategoryItem[] = [
  { id: 1, name: "Board Games", icon: <Blocks /> },
  { id: 2, name: "Gaming Consoles", icon: <Gamepad2 />, image: "/icons/amenities/gamingconsoles.png" },
  { id: 3, name: "Music System", icon: <Music /> },
  { id: 4, name: "Piano", icon: <Music2 />, image: "/icons/amenities/piano.png" },
  { id: 5, name: "Pool Table", icon: <CircleDot />, image: "/icons/amenities/pooltable.png" },
  { id: 6, name: "Television", icon: <Tv />, image: "/icons/amenities/television.png" },
];

/* ──────────────────────────────────────────────
   🧒  CHILDREN AMENITIES
────────────────────────────────────────────── */
export const ChildrenAmenities: CategoryItem[] = [
  { id: 1, name: "Baby Cot", icon: <Baby />, image: "/icons/amenities/babycot.png" },
  { id: 2, name: "Baby Safety Gates", icon: <ShieldCheck /> },
  { id: 3, name: "Children's Books", icon: <BookOpen /> },
  { id: 4, name: "High Chair", icon: <Sofa /> },
  { id: 5, name: "Kids Play Area", icon: <Blocks />, image: "/icons/amenities/playground.png" },
  { id: 6, name: "Toys", icon: <Blocks /> },
];

/* ──────────────────────────────────────────────
   🍽️  KITCHEN AMENITIES
────────────────────────────────────────────── */
export const KitchenAmenities: CategoryItem[] = [
  { id: 1, name: "Bowls", icon: <Soup /> , image: "/icons/amenities/bowls.png"},
  { id: 2, name: "Cooking Pots", icon: <Soup />, image: "/icons/amenities/cookingpots.png" },
  { id: 3, name: "Cups & Mugs", icon: <Coffee />, image: "/icons/amenities/cups.png" },
  { id: 4, name: "Dining Table", icon: <Utensils />, image: "/icons/amenities/dtable.png" },
  { id: 5, name: "Cutlery", icon: <Utensils />, image: "/icons/amenities/cutlery.png" },
  { id: 6, name: "Glasses", icon: <GlassWater />,image: "/icons/amenities/glasses.png" },
  { id: 7, name: "Knives", icon: <Utensils /> ,image: "/icons/amenities/knives.png"},
  { id: 8, name: "Microwave", icon: <Microwave />, image: "/icons/amenities/microwave.png" },
  { id: 9, name: "Plates", icon: <Soup />, image: "/icons/amenities/plates.png" },
  { id: 10, name: "Refrigerator", icon: <Refrigerator />, image: "/icons/amenities/fridge.png" },
  { id: 12, name: "Stove / Cooker", icon: <ChefHat />, image: "/icons/amenities/cooker.png" },
];

/* ──────────────────────────────────────────────
   🧺  LAUNDRY AMENITIES
────────────────────────────────────────────── */
export const LaundryAmenities: CategoryItem[] = [
  { id: 1, name: "Dryer", icon: <Wind />, image: "/icons/amenities/dryer.png" },
  { id: 2, name: "Hangers", icon: <Shirt />, image: "/icons/amenities/hangers.png" },
  { id: 3, name: "Iron", icon: <Wind />, image: "/icons/amenities/iron.png" },
  { id: 4, name: "Washing Machine", icon: <WashingMachine />, image: "/icons/amenities/washer.png" },
];

/* ──────────────────────────────────────────────
   🛏️  BEDROOM AMENITIES
────────────────────────────────────────────── */
export const BedroomAmenities: CategoryItem[] = [
  { id: 1, name: "Bathrobe", icon: <Shirt /> ,image: "/icons/amenities/bathrob.png" },
  { id: 2, name: "Bed Sheets", icon: <Layers />,image: "/icons/amenities/bedsheet.png"  },
  { id: 3, name: "Blackout Curtains", icon: <Blinds />,image: "/icons/amenities/curtains.png"  },
  { id: 4, name: "Blankets", icon: <Archive />,image: "/icons/amenities/blanket.png"  },
  { id: 5, name: "Extra Pillows and Blankets", icon: <BedDouble />, image: "/icons/amenities/pillows.png" },
  { id: 6, name: "Mosquito Net", icon: <Bug /> ,image: "/icons/amenities/mosquitonet.png" },
  { id: 7, name: "Slippers", icon: <Footprints /> ,image: "/icons/amenities/slipper.png" },
];

/* ──────────────────────────────────────────────
   🛁  BATHROOM AMENITIES
────────────────────────────────────────────── */
export const BathroomAmenities: CategoryItem[] = [
  { id: 1, name: "Bathtub", icon: <Bath />, image: "/icons/amenities/bathtub.png" },
  { id: 2, name: "Cleaning Products", icon: <SprayCan />, image: "/icons/amenities/showerset.png" },
  { id: 3, name: "Conditioner", icon: <Droplets />, image: "/icons/amenities/conditioner.png" },
  { id: 4, name: "Hot Water", icon: <Droplet /> },
  { id: 5, name: "Shampoo", icon: <Droplet />, image: "/icons/amenities/shampoo.png" },
  { id: 6, name: "Shower Gel", icon: <ShowerHead />, image: "/icons/amenities/showergel.png" },
  { id: 7, name: "Soap", icon: <Hand />,image: "/icons/amenities/soap.png" },
  { id: 8, name: "Toilet Paper", icon: <ScrollText />,image: "/icons/amenities/toiletpaper.png" },
  { id: 9, name: "Towels", icon: <Layers />, image: "/icons/amenities/towels.png" },
];

/* ──────────────────────────────────────────────
   💼  OFFICE AMENITIES
────────────────────────────────────────────── */
export const OfficeAmenities: CategoryItem[] = [
  { id: 1, name: "Dedicated Workspace", icon: <Briefcase />,image: "/icons/amenities/workspace.png"  },
  { id: 2, name: "Power Outlets / Extension", icon: <PlugZap />, image: "/icons/amenities/adapter.png"  },
  { id: 3, name: "Printer", icon: <Printer />,image: "/icons/amenities/printer.png"  },
  { id: 4, name: "Stationery", icon: <PenTool />, image: "/icons/amenities/stationary.png"  },
  { id: 5, name: "Wi-Fi", icon: <Wifi />, image: "/icons/amenities/wifi.png" },
];

/* ──────────────────────────────────────────────
   🛡️  SAFETY AMENITIES
────────────────────────────────────────────── */
export const safetyCategories: CategoryItem[] = [
  { id: 1, name: "CCTV Surveillance", icon: <Camera />, image: "/icons/amenities/cctv.png" },
  { id: 2, name: "Emergency Exit", icon: <DoorOpen /> },
  { id: 3, name: "Fire Alarm", icon: <Bell />, image: "/icons/amenities/firealarm.png" },
  { id: 4, name: "Fire Extinguisher", icon: <FireExtinguisher />, image: "/icons/amenities/fireextinguisher.png" },
  { id: 5, name: "First Aid Kit", icon: <HeartPulse />, image: "/icons/amenities/firstaidkit.png" },
  { id: 6, name: "Secure Lockbox", icon: <Lock />, image: "/icons/amenities/lockbox.png" },
  { id: 7, name: "Security Alarm", icon: <Siren /> },
  { id: 8, name: "Security Guard", icon: <ShieldCheck /> },
  { id: 9, name: "Sprinkler System", icon: <Droplets />, image: "/icons/amenities/sprinkler.png" },
];

/* ──────────────────────────────────────────────
   📜  RULES
────────────────────────────────────────────── */
export const rulesCategories: CategoryItem[] = [
  { id: 1, name: "Check-In After 3PM", icon: <Clock /> },
  { id: 2, name: "Check-Out Before 11AM", icon: <Clock /> },
  { id: 3, name: "ID Required", icon: <IdCard /> },
  { id: 4, name: "Late Checkout (After 11AM)", icon: <CalendarCheck /> },
  { id: 5, name: "Loud Music Allowed", icon: <Volume2 /> },
  { id: 6, name: "No Food in Bedrooms", icon: <Ban /> },
  { id: 7, name: "No Loud Music", icon: <VolumeX /> },
  { id: 8, name: "No Parties", icon: <VolumeX /> },
  { id: 9, name: "No Pets", icon: <PawPrint />, image: "/icons/amenities/notpetfriendy.png" },
  { id: 10, name: "No Smoking", icon: <CigaretteOff />, image: "/icons/amenities/nosmoking.png" },
  { id: 11, name: "No Unregistered Guests", icon: <UserX /> },
  { id: 12, name: "Parties Allowed", icon: <PartyPopper /> },
  { id: 13, name: "Pets Allowed", icon: <PawPrint />, image: "/icons/amenities/petfriendly.png" },
  { id: 14, name: "Quiet Hours", icon: <Moon /> },
  { id: 15, name: "Smoking Allowed", icon: <Cigarette /> },
];



export const landCategories = [
  { id: 1, name: 'Residential', icon: '🏠' },
  { id: 2, name: 'Commercial', icon: '🏢' },
  { id: 3, name: 'Agriculture', icon: '🌾' },
  { id: 4, name: 'Mixed Use', icon: '🏘️' },
];

export const landmenitiesCategories: CategoryItem[] = [
  {
    id: 1,
    name: 'Water Available',
    icon: <WaterDrop />,
  },
  {
    id: 2,
    name: 'Electricity Connected',
    icon: <ElectricalServices />,
  },
  {
    id: 3,
    name: 'Fenced',
    icon: <Fence />,
  },
  {
    id: 4,
    name: 'Has Structures',
    icon: <HouseSiding />,
  },
];


export const servicesCategories: CategoryItem[] = [
  { id: 1, name: 'Cleaner', icon: <CleaningServices /> },
  { id: 2, name: 'Plumber', icon: <Plumbing /> },
  { id: 3, name: 'Electrician', icon: <ElectricalServices /> },
  { id: 4, name: 'Handyman', icon: <BuildCircle /> },
  { id: 5, name: 'Furniture Assembly', icon: <Weekend /> },
  { id: 6, name: 'Interior Designer', icon: <DesignServices /> },
  { id: 7, name: 'Painter', icon: <FormatPaint /> },
  { id: 8, name: 'Pest Control', icon: <BugReport /> },
  { id: 9, name: 'AC Technician', icon: <AcUnit /> },
  { id: 10, name: 'Carpenter', icon: <Carpenter /> },
  { id: 11, name: 'TV Mounting', icon: <Tv /> },
  { id: 12, name: 'Curtain Installer', icon: <Curtains /> },
  { id: 13, name: 'Gardener', icon: <Park /> },
  { id: 14, name: 'Photographer (Property)', icon: <CameraAlt /> },
  { id: 15, name: 'Home Organizer', icon: <Category /> },
  { id: 16, name: 'Tile Installer', icon: <GridOn /> },
  { id: 17, name: 'Welder (Gates/Grills)', icon: <Build /> },
  { id: 18, name: 'Roof Repair Specialist', icon: <HouseSiding /> },
  { id: 19, name: 'Water Tank Cleaner', icon: <Opacity /> },
  { id: 20, name: 'Window Installer', icon: <CropLandscape /> },
  { id: 21, name: 'CCTV Technician', icon: <Videocam /> },
  { id: 22, name: 'Solar Installer', icon: <WbSunny /> },
  { id: 23, name: 'Locksmith', icon: <VpnKey /> },
  { id: 24, name: 'Floor Polishing', icon: <CleaningServices /> },
  { id: 25, name: 'Trash Hauler / Junk Removal', icon: <Delete /> },
  { id: 26, name: 'Security Guard (Short-Term)', icon: <Security /> },
  { id: 27, name: 'Laundry / Ironing', icon: <LocalLaundryService /> },
  { id: 28, name: 'Pool Cleaner', icon: <Pool /> },
  { id: 29, name: 'Property Valuer', icon: <Assessment /> },
  { id: 30, name: 'Real Estate Agent', icon: <RealEstateAgent /> },
];

export const officeCategories: CategoryItem[] = [
  { id: 1, name: 'Coworking Desk (Hot Desk)', icon: <MeetingRoom /> },
  { id: 2, name: 'Private Office', icon: <HomeWork /> },
  { id: 3, name: 'Meeting Room', icon: <EventAvailable /> },
  { id: 4, name: 'Conference Hall', icon: <Celebration /> },
  { id: 5, name: 'Day Office (Hourly)', icon: <AccessTime /> },
  { id: 6, name: 'Creative Studio', icon: <Videocam /> },
  { id: 7, name: 'Training Room / Classroom', icon: <School /> },
];


// ─── Office Amenities ──────────────────────────────
export const officeAmenities: CategoryItem[] = [
  { id: 1, name: "High-Speed Wi-Fi", icon: <Wifi /> },
  { id: 2, name: "Ergonomic Chairs", icon: <Chair /> },
  { id: 3, name: "Meeting Rooms", icon: <MeetingRoom /> },
  { id: 4, name: "Air Conditioning", icon: <AcUnit /> },
  { id: 5, name: "Coffee / Tea Station", icon: <Coffee /> },
  { id: 6, name: "Kitchenette", icon: <Kitchen /> },
  { id: 7, name: "Printer & Scanner", icon: <Print /> },
  { id: 8, name: "Parking", icon: <LocalParking /> },
  { id: 9, name: "Elevator Access", icon: <Elevator /> },
  { id: 10, name: "24/7 Security", icon: <Security /> },
  { id: 11, name: "Near Public Transport", icon: <DirectionsBus /> },
  { id: 12, name: "Car Access", icon: <DirectionsCar /> },
];

// ─── Office Rules ──────────────────────────────
export const officeRules: CategoryItem[] = [
  { id: 1, name: "No Smoking Indoors", icon: <Block /> },
  { id: 2, name: "Smoking Area Outside", icon: <SmokingRooms /> },
  { id: 3, name: "Keep Noise to Minimum", icon: <MeetingRoom /> },
  { id: 4, name: "Clean Workspace After Use", icon: <Kitchen /> },
  { id: 5, name: "Respect Office Hours", icon: <Chair /> },
  { id: 6, name: "Guests With Approval Only", icon: <Security /> },
];




export const contractorCategories: CategoryItem[] = [
  { id: 1, name: 'General Contractor', icon: <Build /> },
  { id: 2, name: 'Electrical Contractor', icon: <ElectricalServices /> },
  { id: 3, name: 'Plumbing Contractor', icon: <Plumbing /> },
  { id: 4, name: 'HVAC Contractor', icon: <AcUnit /> },
  { id: 5, name: 'Roofing Contractor', icon: <HouseSiding /> },
  { id: 6, name: 'Landscaping Contractor', icon: <Landscape /> },
  { id: 7, name: 'Painting Contractor', icon: <FormatPaint /> },
  { id: 8, name: 'Paving Contractor', icon: <BuildCircle /> },
];
export const proCategories: CategoryItem[] = [
  { id: 1, name: 'Professional Services', icon: <AccountCircle /> },
  { id: 2, name: 'Consulting', icon: <HowToReg /> },
  { id: 3, name: 'Legal Services', icon: <VpnKey /> },
  { id: 4, name: 'Financial Services', icon: <Assessment /> },
  { id: 5, name: 'Marketing Services', icon: <DesignServices /> },
  { id: 6, name: 'IT Services', icon: <Security /> },
];


export const cleaningCategories: CategoryItem[] = [
  // 🏠 Residential Cleaning
{ id: 1, name: "Regular Home Cleaning", icon: <Home /> },
  { id: 2,  name: "Deep Cleaning",               icon: <CleaningServices /> },
  { id: 3,  name: "Move-In / Move-Out Cleaning", icon: <DirectionsCar /> },
  { id: 4,  name: "Bedroom & Linen Cleaning",    icon: <Weekend /> },
  { id: 5,  name: "Kitchen Cleaning",            icon: <Kitchen /> },
  { id: 6,  name: "Bathroom Sanitisation",       icon: <Opacity /> },

  // 🏢 Commercial & Office Cleaning
  { id: 7,  name: "Office Cleaning",             icon: <HomeWork /> },
  { id: 8,  name: "Retail & Shop Cleaning",      icon: <LocalParking /> },
  { id: 9,  name: "Hotel & Hospitality",         icon: <Hotel /> },
  { id: 10, name: "Warehouse & Industrial",      icon: <Warehouse /> },
  { id: 11, name: "Post-Construction Cleaning",  icon: <Build /> },
  { id: 12, name: "Factory Cleaning",            icon: <Factory /> },

  // 🚗 Specialised Cleaning
  { id: 13, name: "Car / Vehicle Cleaning",      icon: <DirectionsCar /> },
  { id: 14, name: "Carpet & Upholstery",         icon: <Weekend /> },
  { id: 15, name: "Window Cleaning",             icon: <CropLandscape /> },
  { id: 16, name: "Waste Removal",               icon: <Delete /> },
  { id: 17, name: "Garden & Outdoor Cleaning",   icon: <Park /> },
];






export const cleaningAmenities: CategoryItem[] = [
  // 🏠 Room / Area Types
  { id: 1,  name: "Entire Home",               icon: <Home /> },
  { id: 2,  name: "1 Bedroom",                 icon: <Hotel /> },
  { id: 3,  name: "2 Bedrooms",                icon: <Hotel /> },
  { id: 4,  name: "3 Bedrooms",                icon: <Hotel /> },
  { id: 5,  name: "4 Bedrooms",                icon: <Hotel /> },
  { id: 6,  name: "5+ Bedrooms",               icon: <Hotel /> },
  { id: 7,  name: "Lounge / Living Room",       icon: <Weekend /> },
  { id: 8,  name: "Kitchen",                   icon: <Kitchen /> },
  { id: 9,  name: "Bathroom",                  icon: <Bathtub /> },
  { id: 10, name: "Floor",                     icon: <CleaningServices /> },
  { id: 11, name: "Windows",                   icon: <CropLandscape /> },
  { id: 12, name: "Walls",                     icon: <HouseSiding /> },
  { id: 13, name: "Ceiling",                   icon: <Landscape /> },
  { id: 14, name: "Staircase",                 icon: <Elevator /> },
  { id: 15, name: "Balcony",                   icon: <Balcony /> },
  { id: 16, name: "Garage",                    icon: <DirectionsCar /> },
  { id: 17, name: "Eco-Friendly Products",     icon: <Landscape /> },
  { id: 18, name: "Own Equipment",             icon: <Build /> },
  { id: 19, name: "Steam Cleaning",            icon: <Opacity /> },
  { id: 20, name: "Vacuum Cleaning",           icon: <HomeWork /> },
  { id: 21, name: "Disinfection Service",      icon: <MedicalServices /> },
  { id: 22, name: "Odour Removal",             icon: <WindPower /> },
  { id: 23, name: "Laundry & Ironing",         icon: <LocalLaundryService /> },
  { id: 24, name: "Carpet Shampooing",         icon: <Weekend /> },
  { id: 25, name: "Tile & Grout Cleaning",     icon: <GridOn /> },
  { id: 26, name: "Sofa & Upholstery",         icon: <Chair /> },
  { id: 27, name: "Pool Cleaning",             icon: <Pool /> },
  { id: 28, name: "Garden Tidying",            icon: <Park /> },
  { id: 29, name: "Waste Removal",             icon: <Delete /> },
  { id: 30, name: "Pressure Washing",          icon: <WaterDrop /> },
  { id: 31, name: "Fridge & Oven Cleaning",    icon: <Kitchen /> },
  { id: 32, name: "Post-Party Cleanup",        icon: <Celebration /> },
  { id: 33, name: "Move-Out Cleaning",         icon: <DirectionsCar /> },
];

export const cleaningSafetyCategories: CategoryItem[] = [
  { id: 1, name: "Insured & Bonded",       icon: <Security /> },
  { id: 2, name: "Trained Staff",          icon: <School /> },
  { id: 3, name: "Wears Gloves",           icon: <MedicalServices /> },
  { id: 4, name: "Wears Mask",             icon: <SmokeFree /> },
  { id: 5, name: "Child Safe Products",    icon: <ChildCare /> },
  { id: 6, name: "Pet Safe Products",      icon: <Pets /> },
  { id: 7, name: "No Harsh Chemicals",     icon: <Landscape /> },
];

export const cleaningRulesCategories: CategoryItem[] = [
  { id: 1,  name: "Client Must Be Present",    icon: <AccountCircle /> },
  { id: 2,  name: "Client Not Required",       icon: <PersonOff /> },
  { id: 3,  name: "No Pets During Service",    icon: <Block /> },
  { id: 4,  name: "Pets Allowed",              icon: <Pets /> },
  { id: 5,  name: "No Smoking on Premises",    icon: <SmokeFree /> },
  { id: 6,  name: "Fragile Items Excluded",    icon: <Notifications /> },
  { id: 7,  name: "Advance Booking Required",  icon: <AccessTime /> },
  { id: 8,  name: "Same Day Booking OK",       icon: <EventAvailable /> },
  { id: 9,  name: "Cancellation 24h Notice",   icon: <Block /> },
  { id: 10, name: "No Cancellation Fee",       icon: <VolumeOff /> },
  { id: 11, name: "Tip Not Expected",          icon: <MusicNote /> },
  { id: 12, name: "Tip Appreciated",           icon: <Celebration /> },
];